export class HrPerIdentificationSubtypeKey {
    private static readonly keyPrefix = 'hrPerIdentificationSubtype';
    public static title = `${HrPerIdentificationSubtypeKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerIdentificationSubtypeKey.keyPrefix}.pageHeader`;
    public static identificationType = `${HrPerIdentificationSubtypeKey.keyPrefix}.identificationType`;
}
